module.exports = __webpack_public_path__ + "img/template-2-mobile.90524d6a.svg";